import { useState } from 'react'
import { createAllocationPriorityRealApi } from '@/services/allocationPriority/realApi'
import type { AllocationPriorityApi } from '@/services/allocationPriority/types'
import AllocationPriorityPageView from './handoff/page.generated'
import { useAllocationPriorityWiring } from './wiring'
import './modalSpacing.css'

export type { ActionCtx, FormState, Option, Row, Wiring } from './handoff/page.generated'

/** LOGISPRD-15139: 항상 v3 실 API 를 쓴다. `api` 는 테스트 주입용이다. */
export default function AllocationPriorityPage({ api: injectedApi }: { api?: AllocationPriorityApi } = {}) {
  const [api] = useState(() => injectedApi ?? createAllocationPriorityRealApi())
  const { wiring, error, ready, capaError } = useAllocationPriorityWiring(api)
  // 첫 조회가 실패하면 초기값(서버 값이 아님)을 정상 데이터처럼 그리지 않고 오류만 보여 준다.
  return (
    <div className="allocation-priority-page">
      {error ? <p role="alert">{error}</p> : null}
      {/* LOGISPRD-14424 REQ-19: CAPA 실패는 순위 화면을 막지 않는다. 첫 조회 실패 alert 와 섞지 않고 따로 알린다. */}
      {capaError ? (
        <p role="status" className="allocation-priority-capa-error">
          CAPA 조회 실패: {capaError}
        </p>
      ) : null}
      {!ready && error ? null : <AllocationPriorityPageView wiring={wiring} />}
    </div>
  )
}
